import axios from "@/libraries/axios/axiosConfig";

export default async function (trailerId, trailerCompany, logosInstalled, browser, location, device, operatingSystem, accessToken) {
  return await axios({
    method: "post",
    url: `${process.env.VUE_APP_EXT_API_URL}api/admin/qr/logosInstalledOnTrailer`,
    headers: { "X-TacLite-AppToken": `${process.env.VUE_APP_TACLITE_APPTOKEN_VALUE}`, Authorization: `Bearer ${accessToken}` },
    data: {
      trailerId: trailerId,
      trailerCompany: trailerCompany,
      logosInstalled: logosInstalled,
      browser: browser,
      location: location,
      device: device,
      operatingSystem: operatingSystem
    }
  }).then(r => r.data)
}